import { GlFilteredSearchSuggestion, GlIcon } from '../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../../../../../../app/assets/javascripts/alert.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { s__, sprintf } from '~/locale';
import BaseToken from '../../../../../../../../app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import { TOKEN_TITLE_STATUS } from '~/vue_shared/components/filtered_search_bar/constants';
import namespaceWorkItemTypesQuery from '~/work_items/graphql/namespace_work_item_types.query.graphql';
import getAllStatusesQuery from 'ee/issues/dashboard/queries/get_all_statuses.query.graphql';
import { getStatuses, sortStatuses } from '../../../../work_items/utils.js?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'WorkItemStatusToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion,
        GlIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            options: [],
            loading: true
        };
    },
    computed: {},
    methods: {
        getActiveOption (options, data) {
            return options.find((option)=>option.name === data);
        },
        fetchAllStatuses (search) {
            return this.$apollo.query({
                query: getAllStatusesQuery,
                variables: {
                    name: search
                }
            }).then(({ data })=>sortStatuses(data.workItemAllowedStatuses.nodes));
        },
        fetchStatusesForNamespace () {
            return this.$apollo.query({
                query: namespaceWorkItemTypesQuery,
                variables: {
                    fullPath: this.config.fullPath
                }
            }).then(({ data })=>getStatuses(data?.namespace?.workItemTypes?.nodes));
        },
        fetchStatuses (search) {
            this.loading = true;
            const query = this.config.fetchAllStatuses ? this.fetchAllStatuses : this.fetchStatusesForNamespace;
            query(search).then((statuses)=>{
                this.options = statuses.map((status)=>({
                        ...status,
                        value: getIdFromGraphQLId(status.id)
                    }));
            }).catch((error)=>{
                const message = sprintf(s__('WorkItemStatus|Options could not be loaded for field: %{dropdownLabel}. Please try again.'), {
                    dropdownLabel: TOKEN_TITLE_STATUS
                });
                createAlert({
                    message,
                    captureError: true,
                    error
                });
            }).finally(()=>{
                this.loading = false;
            });
        },
        getOptionText (option) {
            return option.name;
        }
    }
};
